<app-loader *ngIf="isDisabled"></app-loader>
<div class="modal-header">
    <h6 class="modal-title"><i class="bi bi-shield-check"></i> Trip</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body">
    <form class="g-3" name="VerificationForm" (ngSubmit)="Verification(VerificationForm)" #VerificationForm="ngForm"
        novalidate>
        <div class="row">
            <div class="col-md-12 mb-3">
                <label for="TripName" class="text-label-dark">Trip Name</label>
                <input type="text" class="form-control" placeholder="Ex. Mumbai" id="TripName" name="TripName"
                    [(ngModel)]="Data.TripName" #TripName="ngModel" maxlength="100" required>
                <div class="invalid-feedback">
                    Please enter trip name
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <label for="FromDate" class="text-label-dark">From Date</label>
                <div class="input-group">
                    <input class="form-control" placeholder="DD MMM YYYY" name="FromDate" [(ngModel)]="Data.FromDateObj"
                        ngbDatepicker #FromDate="ngbDatepicker" required />
                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDate.toggle()"
                        type="button"></button>
                    <div class="invalid-feedback">
                        Please enter from date
                    </div>
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <label for="ToDate" class="text-label-dark">To Date</label>
                <div class="input-group">
                    <input class="form-control" placeholder="DD MMM YYYY" name="ToDate" [(ngModel)]="Data.ToDateObj"
                        ngbDatepicker #ToDate="ngbDatepicker" required />
                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDate.toggle()"
                        type="button"></button>
                    <div class="invalid-feedback">
                        Please enter to date
                    </div>
                </div>
            </div>
            <div class="col-md-12 mb-3">
                <label for="Description" class="text-label-dark">Description</label>
                <textarea type="text" class="form-control" placeholder="Ex. 100 Main ST" id="Description"
                    name="Description" [(ngModel)]="Data.Description" #Description="ngModel" maxlength="200"
                    style="height: 70px;"></textarea>
                <div class="invalid-feedback">
                    Please enter description
                </div>
            </div>
        </div>
        <div class="row m-1">
            <button type="submit" class="btn btn-primary" [disabled]="isDisabled">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Submit':'Loading...'}}</button>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled" (click)="close()"><i
            class="bi bi-x" *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'Cancel':'Loading...'}}</button>
</div>